import { useState } from 'react';

import { Button } from '@/components/core/Button';
import { Callout } from '@/components/core/Callout';
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogHeaderDefault,
} from '@/components/core/Dialog';
import { useTranslation } from '@/hooks/useTranslation';

interface CommunicationChannelsErrorDialogProps {
    title: string;
    heading: string;
    message: string;
    onClose: () => void;
}

const CommunicationChannelsErrorDialog = ({
    title,
    heading,
    message,
    onClose,
}: CommunicationChannelsErrorDialogProps) => {
    const [open] = useState(true);
    const { t } = useTranslation();

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent
                onPointerDownOutside={(e) => e.preventDefault()}
                onInteractOutside={(e) => e.preventDefault()}
            >
                <DialogHeader>
                    <DialogHeaderDefault>{title}</DialogHeaderDefault>
                </DialogHeader>
                <DialogBody>
                    <Callout variant="destructive">
                        <b>{heading}</b>
                        <br />
                        <p className="tw-pt-8 tw-whitespace-pre-line">
                            {message}
                        </p>
                    </Callout>
                </DialogBody>
                <DialogFooter>
                    <DialogClose asChild={true}>
                        <Button variant="secondary" type="submit">
                            {t('CANCEL')}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

CommunicationChannelsErrorDialog.displayName =
    'CommunicationChannelsErrorDialog';

export {
    CommunicationChannelsErrorDialog,
    type CommunicationChannelsErrorDialogProps,
};
